export const baseUrl = "https://www.shchangju.com";
